SET_VIDEO_PLAYER_VIDEO_BASIC_VISIBLE